"use strict";

exports.__esModule = true;
exports.default = baseCreate;
var _isObject = _interopRequireDefault(require("./isObject.js"));
var _setup = require("./_setup.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Create a naked function reference for surrogate-prototype-swapping.
function ctor() {
  return function () {};
}

// An internal function for creating a new object that inherits from another.
function baseCreate(prototype) {
  if (!(0, _isObject.default)(prototype)) return {};
  if (_setup.nativeCreate) return (0, _setup.nativeCreate)(prototype);
  var Ctor = ctor();
  Ctor.prototype = prototype;
  var result = new Ctor();
  Ctor.prototype = null;
  return result;
}